var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import useAuthentication from 'hooks/use-authentication';
import { useLazyQuery, useQuery } from '@apollo/client';
import noDataImage from 'assets/images/no-data-exams.svg';
import noDataImageGray from 'assets/images/no-data--exams--gray.svg';
import Loader from 'components/loader/loader';
import Button from 'components/button/button';
import { ButtonStyle } from 'components/button/prop-types';
import { getAccount } from 'services/api/account';
import { getCustomBrandingFromStorage } from 'helpers/customBranding';
import EXAM_QUERY from 'queries/get-exam-by-id.graphql';
import GET_USER_QUERY from 'queries/get-user.graphql';
const NoS2BPage = () => {
    var _a;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [downloadUrl, setDownloadUrl] = useState();
    const [institutionID, setInstitutionID] = useState();
    const { getExamIdFromToken, getUserNameFromToken, getSessionEmail } = useAuthentication();
    const customBranding = getCustomBrandingFromStorage();
    const [getUser] = useLazyQuery(GET_USER_QUERY, {
        fetchPolicy: 'network-only',
    });
    const redirect = () => {
        window.open(downloadUrl, '_blank');
    };
    const { data: dataExam, loading: loadingExam, error: errorExam } = useQuery(EXAM_QUERY, {
        variables: {
            id: getExamIdFromToken(),
        },
    });
    useEffect(() => {
        if (!dataExam) {
            return;
        }
        if (!dataExam.exam.isProctored) {
            navigate('/welcome');
        }
        loadAccountInfo();
    }, [dataExam]);
    const loadAccountInfo = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b, _c, _d;
        const response = yield getUser({
            variables: {
                email: getSessionEmail(),
            },
        });
        const data = response.data;
        if (data === null || data === void 0 ? void 0 : data.user.accountId) {
            const { account: accountData } = yield getAccount(data === null || data === void 0 ? void 0 : data.user.accountId);
            setDownloadUrl((_c = (_b = accountData.institution) === null || _b === void 0 ? void 0 : _b.downloadS2BLink) !== null && _c !== void 0 ? _c : '/download/app/en/us/global/v2');
            setInstitutionID((_d = accountData.institution) === null || _d === void 0 ? void 0 : _d.id);
        }
    });
    return (_jsxs(_Fragment, { children: [loadingExam && (_jsx(Loader, {}, void 0)), !loadingExam && (_jsxs(_Fragment, { children: [_jsx("h2", Object.assign({ className: "title--main" }, { children: t('S2B.WELCOME').replace('USERNAME', (_a = getUserNameFromToken()) !== null && _a !== void 0 ? _a : '') }), void 0), 
                    // If can get the exam info, shows the exam name, if not, only shows the message without the name
                    (errorExam || !dataExam) ? (_jsx("p", { className: "description", dangerouslySetInnerHTML: { __html: `${t('S2B.CANT_TAKE')} <br/>${t('S2B.MUST_DOWNLOAD')}` } }, void 0)) : (_jsx("p", { className: "description", dangerouslySetInnerHTML: { __html: `${t('S2B.CANT_TAKE').replace('{{EXAM_NAME}}', `<span class="text--fetured">${dataExam.exam.title}</span> `)} <br/>${t('S2B.MUST_DOWNLOAD')}` } }, void 0)), _jsx("img", { className: "image--centered image--opacity", src: (customBranding === null || customBranding === void 0 ? void 0 : customBranding.isEnabled) ? noDataImageGray : noDataImage }, void 0), _jsx(Button, { className: [ButtonStyle.Centered], title: t('S2B.DOWNLOAD_BUTTON'), onClick: redirect, loading: !downloadUrl }, void 0), institutionID && (_jsxs("p", Object.assign({ className: 'mt-3' }, { children: [t('S2B.INSTITUTION_ID'), ": ", _jsx("span", Object.assign({ className: "text--fetured" }, { children: institutionID }), void 0)] }), void 0))] }, void 0))] }, void 0));
};
export default NoS2BPage;
